import { apiClient } from '../utils/api-client';
import type { CommentsResponse, CommentResponse } from '../types/comment';
import type { ClimbCommentsResponse } from '../types/comments-grouped';

class CommentsService {
  async getComments(ascentLogId: string): Promise<CommentsResponse> {
    const response = await apiClient.get(`/api/ascent_logs/${ascentLogId}/comments`);
    return await response.json();
  }

  async getCommentsForClimb(climbIdOrSlug: string): Promise<ClimbCommentsResponse> {
    const response = await apiClient.get(`/api/climbs/${climbIdOrSlug}/comments`);
    return await response.json();
  }

  async createComment(ascentLogId: string, body: string): Promise<CommentResponse> {
    const response = await apiClient.post(
      `/api/ascent_logs/${ascentLogId}/comments`,
      { data: { attributes: { body } } },
      { requireAuth: true }
    );
    return await response.json();
  }

  async updateComment(ascentLogId: string, commentId: string, body: string): Promise<CommentResponse> {
    const response = await apiClient.patch(
      `/api/ascent_logs/${ascentLogId}/comments/${commentId}`,
      { data: { attributes: { body } } },
      { requireAuth: true }
    );
    return await response.json();
  }

  async deleteComment(ascentLogId: string, commentId: string): Promise<void> {
    await apiClient.delete(
      `/api/ascent_logs/${ascentLogId}/comments/${commentId}`,
      { requireAuth: true }
    );
  }
}

export const commentsService = new CommentsService();
